import type { ComponentProps } from 'react';

import { General } from '../StrokeIcons';
import BadgeWButton, { BadgeWButtonProps } from './BadgeWButton';

type DeletableBadgeProps = Omit<BadgeWButtonProps, 'bIcon' | 'onButtonClick'> & {
  onDelete: ComponentProps<'div'>['onClick'];
};

export default function DeletableBadge({ onDelete, ...props }: DeletableBadgeProps) {
  return <BadgeWButton bIcon={<General.Trash01 />} {...props} onButtonClick={onDelete} />;
}
